// Main entry point for worker target (client bridge)
import * as Turbo from '@hotwired/turbo';
import { Application } from 'juntos/targets/worker/client.js';
import '../app/javascript/controllers/index.js';
import { layout } from '../app/views/layouts/application.html.erb';
window.Turbo = Turbo;
Application.configure({ layout: layout });
Application.start();
